import { render, staticRenderFns } from "./EditPlanoCliente.vue?vue&type=template&id=1ad4f294&"
import script from "./EditPlanoCliente.vue?vue&type=script&lang=js&"
export * from "./EditPlanoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports